import { buildPropsHelper } from './helpers/props';

export default {
  InputEnter: {
    ...buildPropsHelper(),

    mounted() {
      this.handleKeyDownCallback = this.handleKeyDown.bind(this);

      this.initialize();
    },

    updated() {
      if (this.propsChanged()) {
        this.removeEventListeners();
        this.initialize();
      }
    },

    destroyed() {
      this.removeEventListeners();
    },

    getProps() {
      return {
        blueOnEnter: this.el.dataset.onEnterBlur === 'true',
        onEnterEvent: this.el.dataset.onEnterEvent,
      };
    },

    initialize() {
      this.setProps();
      this.addEventListeners();
    },

    addEventListeners() {
      this.el.addEventListener('keydown', this.handleKeyDownCallback);
    },

    removeEventListeners() {
      this.el.removeEventListener('keydown', this.handleKeyDownCallback);
    },

    handleKeyDown(event) {
      if (event.keyCode === 13) {
        const value = this.el.value;
        const cursorPosition = this.el.selectionStart;

        const [leftValue, rightValue] = [value.substring(0, cursorPosition), value.substring(cursorPosition)];

        // This is de-focusing an element once enter is hit. It is required if you're also changing
        // the value of the input on the backend to propagate that change as LiveView cannot update
        // the field when the field is focused.
        if (this.blurOnEnter) this.el.blur();

        // Prevent default enter behaviour
        event.preventDefault();

        // Handle onEnterEvent
        this.pushEvent(this.onEnterEvent, { left: leftValue, right: rightValue });
      }
    },
  },
};
